<template>
  <nav-tabs-card no-label md-elevation="0">
    <template slot="content">
      <md-tabs md-alignment="left" class="p-0">
        <md-tab md-label="Tables" md-icon="table_chart" class="p-0">
          <div class="md-layout">
            <div class="md-layout-item p-0">
              <md-card-header class="md-card-header-icon m-0">Tables</md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0">
                    <md-card class="md-card-profile m-0">
                      <!-- <md-card-header class="md-card-header-icon">
                        <h4 class="title m-0">
                          <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                            Cash flow-Solvency (Your Firm)
                          </div>
                        </h4>
                      </md-card-header>-->
                      <md-card-content class="border-0">
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableDataFirm"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <template
                                  v-if="report.displaySettings && report.displaySettings.includes(item.name)"
                                >
                                  <md-table-cell
                                    class="md-table-side-label"
                                    md-label="Cash flow-Solvency (Your Firm)"
                                  >
                                    {{ tablesInfo[item.name]['title'] }}
                                    <md-tooltip
                                      md-direction="bottom"
                                    >{{ tablesInfo[item.name]['rollover'] }}</md-tooltip>
                                  </md-table-cell>
                                  <md-table-cell md-label="Trend" class="table_chart">
                                    <chart-card
                                      header-animation="false"
                                      :chart-data="newChartFirmOptions[item.name].data"
                                      :chart-options="chartOptions"
                                      chart-type="Line"
                                      header-icon
                                      chart-inside-content
                                      no-footer
                                      background-color="blue"
                                    ></chart-card>
                                  </md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="key"
                                  >{{ item.dates[key] }}</md-table-cell>
                                </template>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0">
                    <md-card class="md-card-profile m-0">
                      <!-- <md-card-header class="md-card-header-icon">
                        <h4 class="title m-0">
                          <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                            Cash flow-Solvency (Industry)
                          </div>
                        </h4>
                      </md-card-header>-->
                      <md-card-content class="border-0">
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableDataIndustry"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <template
                                  v-if="report.displaySettings && report.displaySettings.includes(item.name)"
                                >
                                  <md-table-cell
                                    class="md-table-side-label"
                                    md-label="Cash flow-Solvency (Industry)"
                                  >
                                    {{ tablesInfo[item.name]['title'] }}
                                    <md-tooltip
                                      md-direction="bottom"
                                    >{{ tablesInfo[item.name]['rollover'] }}</md-tooltip>
                                  </md-table-cell>
                                  <md-table-cell md-label="Trend" class="table_chart">
                                    <chart-card
                                      header-animation="false"
                                      :chart-data="newChartIndustryOptions[item.name].data"
                                      :chart-options="chartOptions"
                                      chart-type="Line"
                                      header-icon
                                      chart-inside-content
                                      no-footer
                                      background-color="blue"
                                    ></chart-card>
                                  </md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="key"
                                  >{{ item.dates[key] }}</md-table-cell>
                                </template>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
                <div class="md-layout p-4">
                  <div
                    v-for="(chart, index) in charts"
                    :key="index"
                    class="md-layout-item box-ratio md-medium-size-100 md-size-50"
                  >
                    <md-card class="md-card-profile m-0">
                      <md-card-content class="border-0">
                        <chart-card
                          header-animation="false"
                          :chart-data="chart.data"
                          :chart-options="chart.options"
                          chart-type="Line"
                          header-icon
                          chart-inside-content

                          class="horizFooter"
                          background-color="blue"
                        >
                          <template slot="chartInsideHeader">
                            <h4 class="title m-0">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                              >{{ chart.title }}</div>
                            </h4>
                            <!-- <h4 class="title">{{ chart.title }}</h4> -->

                            <div class="md-button-content">
                              <md-icon v-for="(v, i) in getStars(chart.score)" :key="i">{{ v }}</md-icon>
                             </div>

                           </template>
                              <template slot="footer">
                              <div class="pie-line">
                                    <ul>
                                      <li><span><i class="fa fa-square red-color"></i></span>Cash flow-Solvency (Your Firm)</li>
                                      <li><span><i class="fa fa-square sky-blue-color"></i></span>Cash flow-Solvency (Industry) </li>
                                    </ul>
                                  </div>
                              </template>

                         </chart-card>

                           </md-card-content>
                      </md-card>

                  </div>
                </div>
              </md-card-content>
            </div>
          </div>
        </md-tab>
        <md-tab md-label="Variance" md-icon="dashboard" class="p-0">
          <div class="md-layout">
            <div class="md-layout-item p-0">
              <md-card-header class="md-card-header-icon m-0">Variance</md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0">
                    <md-card class="md-card-profile m-0">
                      <!-- <md-card-header class="md-card-header-icon">
                        <h4 class="title m-0">
                          <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                            Cash flow-Solvency
                          </div>
                        </h4>
                      </md-card-header>-->
                      <md-card-content class="border-0">
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableDataVariance"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <template
                                  v-if="report.displaySettings && report.displaySettings.includes(item.name)"
                                >
                                  <md-table-cell class="md-table-side-label">
                                    {{ tablesInfo[item.name]['title'] }}
                                    <md-tooltip
                                      md-direction="bottom"
                                    >{{ tablesInfo[item.name]['rollover'] }}</md-tooltip>
                                  </md-table-cell>
                                  <md-table-cell md-label="Trend" class="table_chart">
                                    <chart-card
                                      header-animation="false"
                                      :chart-data="newChartVarianceOptions[item.name].data"
                                      :chart-options="chartOptions"
                                      chart-type="Line"
                                      header-icon
                                      chart-inside-content
                                      no-footer
                                      background-color="blue"
                                    ></chart-card>
                                  </md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="key"
                                  >{{ item.dates[key] }}</md-table-cell>

                                </template>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
               </md-card-content>
            </div>
          </div>
        </md-tab>
      </md-tabs>
    </template>
  </nav-tabs-card>
</template>

<script>
import { Collapse } from '@/components';
import { ChartCard, NavTabsCard } from "@/components";
import { mapState } from 'vuex';
import formatData from "@/mixins/format-data";
import ratingMixin from "@/mixins/rating-mixin";

export default {
  components: {
    ChartCard,
    NavTabsCard,
    // Collapse,
  },

  mixins: [formatData, ratingMixin],

  data() {
    return {
      view: "cash-flow-solvency",
      newChartVarianceOptions: [],
      newChartFirmOptions: [],
      newChartIndustryOptions: [],
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      showDialog: false,
      tableDataVariance: [],
      tableDataIndustry: [],
      tableDataFirm: [],
      charts: [],
      options: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 10,
        }),
        axisY: {
          showGrid: true,
          offset: 40,
        },
        axisX: {
          showGrid: false,
        },
        low: 0,
        showPoint: true,
        height: '250px',
      },
    };
  },
  computed: {
    ...mapState({
      years: state => state.user.report.years,
      table: state => state.user.report.tables['ratios']['cashflow'],
      tablesInfo: state => state.user.report.tables['ratioInfo'],
      showYears: state => state.user.report.showYears,
      report: state => state.user.report
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = "cash-flow-solvency";
    }

    this.switchView(section);
    let filtered_years = [];
    this.showYears.forEach((s, i) => {
      if (s) {
        filtered_years.push(this.years[i]);
      }
    });
    if (!filtered_years.length) {
      filtered_years = this.years;
    }
    
    this.tableDataVariance = this.formatTable(this.table, 'variance');
  
    this.tableDataVariance = this.tableDataVariance.map(item => {
      let changeDates = Object.keys(item.dates)
      changeDates = changeDates.filter(fItem => {
        return !filtered_years.includes(fItem);
      })
      let newDates = item.dates
      changeDates.map(el => {
        delete newDates[el]
      })
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj
    })
    this.tableDataVariance.forEach(element => {
      this.newChartVarianceOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]]
        },
      }
    });
    this.tableDataFirm = this.formatTable(this.table, 'firm');
    this.tableDataFirm = this.tableDataFirm.map(item => {
      let changeDates = Object.keys(item.dates)
      changeDates = changeDates.filter(fItem => {
        return !filtered_years.includes(fItem);
      })
      let newDates = item.dates
      changeDates.map(el => {
        delete newDates[el]
      })
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj
    })
    this.tableDataFirm.forEach(element => {
      this.newChartFirmOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]]
        },
      }
    });
    this.tableDataIndustry = this.formatTable(this.table, 'industry');
    this.tableDataIndustry = this.tableDataIndustry.map(item => {
      let changeDates = Object.keys(item.dates)
      changeDates = changeDates.filter(fItem => {
        return !filtered_years.includes(fItem);
      })
      let newDates = item.dates
      changeDates.map(el => {
        delete newDates[el]
      })
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj
    })
    this.tableDataIndustry.forEach(element => {
      this.newChartIndustryOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]]
        },
      }
    });
    if (this.report.chartData) {
      if (this.report.chartData['ratios']) {
        let chartData = this.report.chartData['ratios']['cashflow'];
        this.charts = this.formatMultipleChart(chartData);
      } else {
        let chartData = [];
      }
    }
    else {
      let chartData = [];
    }
  },
  watch: {
    "$route.query.section"() {
      let section = this.$route.query.section;

      if (!section) {
        section = "cash-flow-solvency";
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
  },
};
</script>
<style lang="scss">
.ratios-report {
  .md-button-content {
    .md-icon {
      color: #3b7ef1 !important;
    }
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
    h4 {
      margin-top: 0;
    }
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .finanical-report-messages {
    display: flex;
    justify-content: space-between;
  }
  .messages-box {
    border-radius: 3px;
    background-color: #cccccc;
    padding: 1px !important;
    margin: 10px 30px;

    .md-ripple {
      display: flex;
      align-items: center;
      .md-icon {
        font-size: 1.1rem !important;
        color: #78909c;
      }
    }
  }
  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}

.md-dialog {
  .md-dialog-container {
    max-width: 920px;
    padding: 45px;
    position: relative;
    left: 66px;
  }
}
</style>
